import { useEffect, useState } from "react";
import { Home, BarChart3, Users } from "lucide-react";

const LINKS = [
  { id: "home", label: "Home", icon: Home, target: "#top" },
  { id: "results", label: "Results", icon: BarChart3, target: "#results" },
  { id: "about", label: "About", icon: Users, target: "#about" },
];

export default function Nav() {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 30);
      if (y > 80 && y > lastY + 4) {
        setHidden(true);
      } else if (y < lastY - 4 || y <= 80) {
        setHidden(false);
      }
      lastY = y;
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-4 md:top-5 left-0 right-0 z-50 transition-all duration-500 ${
        hidden ? "-translate-y-[140%] opacity-0 pointer-events-none" : "translate-y-0 opacity-100"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 flex items-center justify-between gap-4">
        {/* Logo */}
        <a href="#top" data-testid="nav-logo" className="flex items-center text-[#0a0a0a]">
          <span className="font-bold tracking-[0.08em] uppercase text-[15px] md:text-[16px]">VIRALX MEDIA</span>
        </a>

        {/* Center pill nav */}
        <nav
          className={`hidden lg:flex items-center gap-0.5 p-1 rounded-full border border-black/10 bg-white/80 backdrop-blur ${
            scrolled ? "shadow-[0_8px_30px_rgba(0,0,0,0.5)]" : ""
          }`}
          data-testid="nav-pill"
        >
          {LINKS.map((l) => {
            const Icon = l.icon;
            const isActive = active === l.id;
            return (
              <a
                key={l.id}
                href={l.target}
                onClick={() => setActive(l.id)}
                data-testid={`nav-link-${l.id}`}
                className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-[12.5px] transition-all whitespace-nowrap ${
                  isActive
                    ? "bg-[#0a0a0a] text-white shadow-[0_1px_0_rgba(255,255,255,0.10)_inset]"
                    : "text-[#0a0a0a]/60 hover:text-[#0a0a0a]"
                }`}
              >
                <Icon className="w-3.5 h-3.5" strokeWidth={2} />
                {l.label}
              </a>
            );
          })}
        </nav>

        {/* Apply CTA — persistent gold money button */}
        <a
          href="https://forms.tgc.chat/book-now"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta"
          className="group inline-flex items-center gap-2 rounded-full font-semibold text-[13px] px-4 py-2.5 md:px-5 transition-transform hover:scale-[1.03]"
          style={{
            background:
              "linear-gradient(180deg, #f8e29a 0%, #e2be5f 45%, #c69a3c 100%)",
            color: "#0a0a0a",
            boxShadow:
              "0 14px 30px -12px rgba(212,175,55,0.6), 0 0 0 1px rgba(212,175,55,0.35) inset, 0 1px 0 rgba(255,255,255,0.4) inset",
          }}
        >
          Apply Now
          <span
            className="inline-flex items-center justify-center w-6 h-6 rounded-full transition-transform duration-300 group-hover:translate-x-0.5"
            style={{ background: "#0a0a0a", color: "#f6dd8b" }}
          >
            →
          </span>
        </a>
      </div>
    </header>
  );
}
